// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/editor_textarea.js

import React, { useEffect, useState } from 'react';
import { Editor } from 'primereact/editor';
import styles from '../styles/editor_textarea.module.scss';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const TextEditor = ({ value, onContentChange }) => {
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  const handleTextChange = (e) => {
    const newValue = e.htmlValue;
    setText(newValue);
    if (onContentChange) {
      onContentChange(newValue);
    }
  };

  // 1. สร้าง Header Template สำหรับ Toolbar ของเราเอง
  const renderHeader = () => {
    return (
      <span className="ql-formats">

        <span className="ql-formats">
          <select className="ql-color"></select>
          <select className="ql-background"></select>
        </span>

        <select className="ql-size" defaultValue="0">
          <option value="small">Small</option>
          <option value="0">Normal</option>
          <option value="large">Large</option>
          <option value="huge">Huge</option>
        </select>

        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
        <button className="ql-strike" aria-label="Strike"></button>
        <button className="ql-list" value="ordered" aria-label="Ordered List"></button>
        <button className="ql-list" value="bullet" aria-label="Unordered List"></button>
        <select className="ql-align" aria-label="Alignment"></select>
        <button className="ql-blockquote" aria-label="Blockquote"></button>
        <button className="ql-code-block" aria-label="Code Block"></button>
        <button className="ql-link" aria-label="Link"></button>
        <button className="ql-clean" aria-label="Remove Formatting"></button>
        {/* สังเกตว่าเราไม่ได้ใส่ปุ่ม <button className="ql-image"></button> เข้ามา */}
      </span>
    );
  };

  const header = renderHeader();

  return (
    <div className={styles.editorContainer}>
      <Editor
        value={text}
        onTextChange={handleTextChange}
        style={{ height: '320px' }}
        // 2. ใช้ headerTemplate แทน toolbar
        headerTemplate={header}
        className={styles.editor}
      />
    </div>
  );
};

export default TextEditor;